import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Botpoison from '@botpoison/browser';
import { SocialIcon } from 'react-social-icons';
import './App.css';
import logo from './assets/logo.png';

// Import team photos (cropped versions)
import teamPhoto from './assets/team/team.png';
import alexanderPhoto from './assets/team cropped/Arquitecto. Alexander Pereyra Alva-personal técnico.png';
import yaninaPhoto from './assets/team cropped/Ing. Yanina Lisett Pereyra Herrera-Personal técnico.png';
import fioreliPhoto from './assets/team cropped/Ing. Fioreli Pereyra Herrera-Asesora inmobiliaria-fotor.png';
import lizethPhoto from './assets/team cropped/Lic. Lizeth Llamo Cotrina-Asesora inmobiliaria.png';
import herlinPhoto from './assets/team cropped/Ing. Herlin Cieza pereyra-Asesor inmobiliario.png';
import cleisiPhoto from './assets/team cropped/Ing. Cleisi Goicochea Ramirez-Asesora inmobiliaria.jpeg';
import andersonPhoto from './assets/team cropped/Cont. Anderson León Chávez-Asesor inmobiliario.png';

// Import project photos (cropped versions)
import casaZPhoto from './assets/projects cropped/Casa Z.png';
import casaMGPhoto from './assets/projects cropped/Casa MG.png';
import casaEstrellaPhoto from './assets/projects cropped/Casa Estrella.png';
import edificioDiazPhoto from './assets/projects cropped/Edificio DIAZ.png';
import edificioNunezPhoto from './assets/projects cropped/Edificio NUÑEZ.png';
import edificioSajamiPhoto from './assets/projects cropped/Edificio SAJAMI.png';
import proyectoEstrellaPhoto from './assets/projects cropped/Proyecto Estrella.png';
import multifamiliarModerno6Photo from './assets/projects cropped/Edificio Multifamiliar moderno-6 niveles.png';
import multifamiliarModerno4Photo from './assets/projects cropped/Edificio Multifamiliar moderno-4 niveles.png';
import proyectoHildaPhoto from './assets/projects cropped/Proyecto Multifamilar-HILDA.png';
import villaShaddaiPhoto from './assets/projects cropped/Proyecto Ecológico-Shaddai.png';

interface TeamMember {
  name: string;
  position: string;
  photo: string;
  bio: string;
  phone?: string;
  email?: string;
}

interface Project {
  name: string;
  description: string;
  photo: string;
}

interface ContactFormData {
  name: string;
  email: string;
  whatsapp: string;
  message: string;
}

// Initialize Botpoison
const botpoison = new Botpoison({
  publicKey: "pk_17036da9-8add-4c0b-84c0-6305b558dd0b"
});

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [currentTeamMember, setCurrentTeamMember] = useState(0);
  const [currentProject, setCurrentProject] = useState(0);
  const [teamTransitionDirection, setTeamTransitionDirection] = useState<'left' | 'right'>('right');
  const [projectTransitionDirection, setProjectTransitionDirection] = useState<'left' | 'right'>('right');
  const [contactForm, setContactForm] = useState<ContactFormData>({
    name: '',
    email: '',
    whatsapp: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  // Touch handling for carousels
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);

  // Set OpenGraph meta tags
  useEffect(() => {
    // Set basic meta tags
    document.title = "Pereyra Inmobiliaria e Ingeniería - La inmobiliaria #1 del norte del Perú";

    // Create or update meta tags
    const setMetaTag = (property: string, content: string) => {
      let metaTag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    const setMetaTagName = (name: string, content: string) => {
      let metaTag = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('name', name);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    // OpenGraph tags
    setMetaTag('og:title', 'Pereyra Inmobiliaria e Ingeniería - La inmobiliaria #1 del norte del Perú');
    setMetaTag('og:description', 'Te ayudamos a cumplir el sueño de tu vivienda propia con experiencia, confianza y compromiso. Diseño Arquitectónico • Construcción • Venta de Inmuebles');
    setMetaTag('og:image', `${window.location.origin}/logo.png`);
    setMetaTag('og:url', window.location.href);
    setMetaTag('og:type', 'website');
    setMetaTag('og:site_name', 'Pereyra Inmobiliaria e Ingeniería');

    // Twitter Card tags
    setMetaTagName('twitter:card', 'summary_large_image');
    setMetaTagName('twitter:title', 'Pereyra Inmobiliaria e Ingeniería - La inmobiliaria #1 del norte del Perú');
    setMetaTagName('twitter:description', 'Te ayudamos a cumplir el sueño de tu vivienda propia con experiencia, confianza y compromiso.');
    setMetaTagName('twitter:image', `${window.location.origin}/logo.png`);

    // Standard meta tags
    setMetaTagName('description', 'Pereyra Inmobiliaria e Ingeniería es la empresa inmobiliaria más confiable del norte del Perú. Ofrecemos servicios de diseño arquitectónico, construcción y venta de inmuebles en Cajamarca.');
    setMetaTagName('keywords', 'inmobiliaria, bienes raíces, construcción, arquitectura, venta de casas, Perú, Cajamarca, diseño arquitectónico');
    setMetaTagName('author', 'Pereyra Inmobiliaria e Ingeniería');
  }, []);

  const teamMembers: TeamMember[] = [
    {
      name: "Yanina Lisett Pereyra Herrera",
      position: "Ing. Civil - CIP: 339228",
      photo: yaninaPhoto,
      bio: "Ingeniera Civil con más de 6 años de experiencia en el desarrollo, supervisión y gestión de proyectos de infraestructura, edificación y urbanismo. Se desempeña como gerente general de la empresa, aportando su conocimiento técnico y visión estratégica para contribuir al desarrollo sostenible del entorno.",
      phone: "964990661",
      email: "yani.04.ph@gmail.com"
    },
    {
      name: "Alexander Pereyra Alva",
      position: "Arquitecto - CAP: 22306",
      photo: alexanderPhoto,
      bio: "El arquitecto Alexander Pereyra Alva cuenta con más de 10 años de experiencia en el diseño y desarrollo de proyectos arquitectónicos residenciales, comerciales e institucionales, ha consolidado una trayectoria sólida en el sector, destacándose por su enfoque integral, su sensibilidad estética y su compromiso con la funcionalidad y la sostenibilidad."
    },
    {
      name: "Fioreli Pereyra Herrera",
      position: "Asesora Inmobiliaria",
      photo: fioreliPhoto,
      bio: "Ingeniera Egresada de la Universidad Nacional Pedro Ruiz Gallo - Lambayeque, con una amplia experiencia en el sector de bienes raíces, mi pasión es ayudar y acompañar a las personas a encontrar el hogar ideal con seguridad y confianza.",
      phone: "901202357",
      email: "fiorelipereyra@gmail.com"
    },
    {
      name: "Lizeth Llamo Cotrina",
      position: "Asesora Inmobiliaria",
      photo: lizethPhoto,
      bio: "Mi pasión es ayudar a las personas a encontrar su hogar soñado. Con enfoque personalizado y profesional, ofrezco asesoramiento experto para compradores y vendedores.",
      phone: "940 878 272",
      email: "cotrinal011@gmail.com"
    },
    {
      name: "Herlin Yomar Cieza Pereyra",
      position: "Asesor Inmobiliario",
      photo: herlinPhoto,
      bio: "Ingeniero Agroindustrial de profesión, desempeño el rol de Asesor Inmobiliario, donde combino mis habilidades analíticas, mi orientación al cliente y mi compromiso con la excelencia para brindar un servicio profesional.",
      phone: "971927807",
      email: "herlincp.15@gmail.com"
    },
    {
      name: "Cleisi Goicochea Ramirez",
      position: "Asesora Inmobiliaria",
      photo: cleisiPhoto,
      bio: "Ingeniera egresada de la Universidad Nacional Pedro Ruiz Gallo-Lambayeque, mi enfoque es acompañar exitosamente a familias, inversionistas y empresas en el proceso de encontrar propiedades que se ajusten a sus necesidades.",
      phone: "956730669",
      email: "kleisig5@hotmail.com"
    },
    {
      name: "Anderson León Chávez",
      position: "Asesor Inmobiliario",
      photo: andersonPhoto,
      bio: "Estudiante de Contabilidad, asesor inmobiliario con amplia experiencia en la compra, venta y renta de propiedades residenciales y comerciales. Su prioridad es ofrecer soluciones efectivas que respondan a las necesidades reales.",
      phone: "900579920",
      email: "elleoninmobiliario@gmail.com"
    }
  ];

  const projects: Project[] = [
    {
      name: "EDIFICIO ESTRELLA",
      description: "Vivienda moderna de 4 niveles - Chiclayo",
      photo: proyectoEstrellaPhoto
    },
    {
      name: "CASA ESTRELLA",
      description: "Vivienda moderna de 3 niveles - Chiclayo",
      photo: casaEstrellaPhoto
    },
    {
      name: "EDIFICIO MULTIFAMILIAR MODERNO",
      description: "Vivienda moderna de 6 niveles - Chiclayo",
      photo: multifamiliarModerno6Photo
    },
    {
      name: "CASA Z",
      description: "Vivienda moderna de 3 niveles con patio grande, zona de parrillas y piscina - La Victoria, Chiclayo",
      photo: casaZPhoto
    },
    {
      name: "CASA MG",
      description: "Vivienda moderna con dos fachadas de 2 niveles - Urb. Casa Blanca, Chiclayo",
      photo: casaMGPhoto
    },
    {
      name: "EDIFICIO DÍAZ",
      description: "Vivienda moderna de 4 niveles - Chiclayo",
      photo: edificioDiazPhoto
    },
    {
      name: "PROYECTO MULTIFAMILIAR HILDA",
      description: "Vivienda moderna de 5 niveles con patio y piscina - Chiclayo",
      photo: proyectoHildaPhoto
    },
    {
      name: "EDIFICIO NUÑEZ",
      description: "Vivienda moderna de 5 niveles - Chiclayo",
      photo: edificioNunezPhoto
    },
    {
      name: "VILLA SHADDAI",
      description: "Proyecto Ecológico - Chiclayo",
      photo: villaShaddaiPhoto
    },
    {
      name: "EDIFICIO MULTIFAMILIAR MODERNO",
      description: "4 niveles - Chiclayo",
      photo: multifamiliarModerno4Photo
    },
    {
      name: "EDIFICIO SAJAMI",
      description: "Proyecto multifamiliar de 4 niveles - Chiclayo",
      photo: edificioSajamiPhoto
    }
  ];

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const handleContactFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setContactForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleContactFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      // Process Botpoison challenge
      const { solution } = await botpoison.challenge();

      // Submit to Formspark
      await axios.post('https://submit-form.com/xxmYUFrUH', {
        ...contactForm,
        _botpoison: solution,
      });

      setSubmitMessage('¡Gracias! Tu mensaje ha sido enviado correctamente. Te contactaremos pronto.');
      setContactForm({ name: '', email: '', whatsapp: '', message: '' });
    } catch (error) {
      setSubmitMessage('Hubo un error al enviar tu mensaje. Por favor, inténtalo de nuevo.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const changeTeamMember = (direction: number) => {
    setTeamTransitionDirection(direction > 0 ? 'right' : 'left');
    setCurrentTeamMember(prev => {
      let next = prev + direction;
      if (next < 0) next = teamMembers.length - 1;
      if (next >= teamMembers.length) next = 0;
      return next;
    });
  };

  const goToTeamMember = (index: number) => {
    const direction = index > currentTeamMember ? 'right' : 'left';
    setTeamTransitionDirection(direction);
    setCurrentTeamMember(index);
  };

  const changeProject = (direction: number) => {
    setProjectTransitionDirection(direction > 0 ? 'right' : 'left');
    setCurrentProject(prev => {
      let next = prev + direction;
      if (next < 0) next = projects.length - 1;
      if (next >= projects.length) next = 0;
      return next;
    });
  };

  const goToProject = (index: number) => {
    const direction = index > currentProject ? 'right' : 'left';
    setProjectTransitionDirection(direction);
    setCurrentProject(index);
  };

  const changeTestimonial = (direction: number) => {
    const totalTestimonials = 3;
    setCurrentTestimonial(prev => {
      let next = prev + direction;
      if (next < 0) next = totalTestimonials - 1;
      if (next >= totalTestimonials) next = 0;
      return next;
    });
  };

  const goToTestimonial = (index: number) => {
    setCurrentTestimonial(index);
  };

  // Handle touch events for swiping
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = (carouselType: 'team' | 'project') => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (carouselType === 'team') {
      if (isLeftSwipe) {
        changeTeamMember(1);
      } else if (isRightSwipe) {
        changeTeamMember(-1);
      }
    } else if (carouselType === 'project') {
      if (isLeftSwipe) {
        changeProject(1);
      } else if (isRightSwipe) {
        changeProject(-1);
      }
    }
  };

  return (
    <div className="App">
      {/* Header */}
      <header className="header" role="banner">
        <div className="container">
          <nav className="nav-container" role="navigation" aria-label="Navegación principal">
            <img src={logo} alt="Pereyra Inmobiliaria e Ingeniería - Logo de la empresa inmobiliaria más confiable del norte del Perú" className="logo" />

            {/* Desktop Navigation */}
            <nav className="desktop-nav" aria-label="Navegación principal desktop">
              <button onClick={() => scrollToSection('inicio')} className="nav-link" aria-label="Ir a inicio">Inicio</button>
              <button onClick={() => scrollToSection('nosotros')} className="nav-link" aria-label="Ir a quiénes somos">Nosotros</button>
              <button onClick={() => scrollToSection('equipo')} className="nav-link" aria-label="Ir a nuestro equipo">Equipo</button>
              <button onClick={() => scrollToSection('proyectos')} className="nav-link" aria-label="Ir a nuestros proyectos">Proyectos</button>
              <button onClick={() => scrollToSection('testimonios')} className="nav-link" aria-label="Ir a testimonios">Testimonios</button>
              <button onClick={() => scrollToSection('contacto')} className="nav-link" aria-label="Ir a contacto">Contacto</button>
            </nav>

            <a href="tel:+51964990661" className="mobile-phone-link">+51 964 990 661</a>

            {/* Mobile Menu Button */}
            <button
              className="mobile-menu-btn"
              onClick={(e) => {
                e.stopPropagation();
                setIsMenuOpen(!isMenuOpen);
              }}
              aria-label={isMenuOpen ? "Cerrar menú" : "Abrir menú"}
              aria-expanded={isMenuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </nav>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <nav className="mobile-nav" aria-label="Navegación móvil">
              <button onClick={(e) => {
                e.stopPropagation();
                scrollToSection('inicio');
                setIsMenuOpen(false);
              }} className="mobile-nav-link">Inicio</button>
              <button onClick={(e) => {
                e.stopPropagation();
                scrollToSection('nosotros');
                setIsMenuOpen(false);
              }} className="mobile-nav-link">Nosotros</button>
              <button onClick={(e) => {
                e.stopPropagation();
                scrollToSection('equipo');
                setIsMenuOpen(false);
              }} className="mobile-nav-link">Equipo</button>
              <button onClick={(e) => {
                e.stopPropagation();
                scrollToSection('proyectos');
                setIsMenuOpen(false);
              }} className="mobile-nav-link">Proyectos</button>
              <button onClick={(e) => {
                e.stopPropagation();
                scrollToSection('testimonios');
                setIsMenuOpen(false);
              }} className="mobile-nav-link">Testimonios</button>
              <button onClick={(e) => {
                e.stopPropagation();
                scrollToSection('contacto');
                setIsMenuOpen(false);
              }} className="mobile-nav-link">Contacto</button>
            </nav>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <main>
        <section id="inicio" className="hero" role="banner">
          <div className="hero-video" aria-hidden="true">
            <div className="video-overlay"></div>
            <iframe
              src="https://player.vimeo.com/video/1089776170?h=0daf98fdcd&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1&amp;loop=1&amp;muted=1&amp;controls=0&amp;title=0&amp;byline=0&amp;portrait=0"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
              title="Video promocional de Pereyra Inmobiliaria e Ingeniería - Los agentes inmobiliarios más confiables del norte del Perú"
              loading="eager"
            ></iframe>
          </div>
          <div className="hero-content">
            <div className="container">
              <h1 className="hero-title">La inmobiliaria #1 del norte del Perú</h1>
              <p className="hero-subtitle">
                Te ayudamos a cumplir el sueño de tu vivienda propia con experiencia, confianza y compromiso
              </p>
              <div className="hero-cta">
                <button onClick={() => scrollToSection('contacto')} className="cta-button" aria-label="Contactar con Pereyra Inmobiliaria">
                  Contáctanos
                </button>
                <div className="hero-badge">
                  <span>Diseño Arquitectónico • Construcción • Venta de Inmuebles</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section id="nosotros" className="about">
          <div className="container">
            <h2 className="about-main-title">¿Quiénes Somos?</h2>

            <div className="about-intro">
              <article className="about-text-intro">
                <p>
                  Pereyra Inmobiliaria e Ingeniería es mucho más que una empresa dedicada a los bienes raíces y la ingeniería.
                  Somos un equipo humano comprometido, empático y apasionado por ayudar a las personas a construir o encontrar
                  ese lugar especial al que llamarán hogar.
                </p>
                <p>
                  Entendemos que una vivienda no es solo una estructura de ladrillos y cemento, sino un espacio cargado de
                  sueños, identidad y proyectos de vida. Por eso, nos involucramos con cada cliente de forma cercana y
                  personalizada, acompañándolos en una de las decisiones más importantes de su vida.
                </p>
              </article>
              <aside className="about-image-intro">
                <img src={teamPhoto} alt="Equipo profesional de Pereyra Inmobiliaria e Ingeniería - Especialistas en bienes raíces y construcción en Chiclayo, Perú" />
              </aside>
            </div>

            <div className="values">
              <h3>Nuestros Valores</h3>
              <div className="values-grid">
                <article className="value-item">
                  <h4>Empatía y Cercanía</h4>
                  <p>Nos conectamos genuinamente con las personas, escuchando y comprendiendo sus necesidades.</p>
                </article>
                <article className="value-item">
                  <h4>Compromiso</h4>
                  <p>Asumimos cada proyecto con responsabilidad, dedicación y excelencia.</p>
                </article>
                <article className="value-item">
                  <h4>Ética</h4>
                  <p>Actuamos con transparencia, respeto y honestidad en cada paso del proceso.</p>
                </article>
                <article className="value-item">
                  <h4>Profesionalismo</h4>
                  <p>Combinamos experiencia, formación y calidad técnica para garantizar resultados confiables.</p>
                </article>
              </div>
            </div>

            <div className="contact-social-links">
              <h3>Síguenos en redes sociales</h3>
              <div className="contact-social-buttons">
                <SocialIcon
                  url="https://www.facebook.com/share/19GkcGLmHz/"
                  target="_blank"
                  style={{ height: 40, width: 40 }}
                  aria-label="Visitar Facebook de Pereyra Inmobiliaria"
                />
                <SocialIcon
                  url="https://www.instagram.com/pereyra_inmobiliaria?igsh=MWtwZ3VwbThnanExdw=="
                  target="_blank"
                  style={{ height: 40, width: 40 }}
                  aria-label="Visitar Instagram de Pereyra Inmobiliaria"
                />
                <SocialIcon
                  network="tiktok"
                  url="https://tiktok.com/@pereyra_inmobiliaria4268"
                  target="_blank"
                  style={{ height: 40, width: 40 }}
                  aria-label="Visitar TikTok de Pereyra Inmobiliaria"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section id="equipo" className="team">
          <div className="container">
            <h2>Nuestro Equipo</h2>
            <p className="section-subtitle">
              Contamos con un grupo multidisciplinario de profesionales altamente cualificados y comprometidos con la excelencia
            </p>

            {/* Desktop Grid */}
            <div className="team-grid">
              {teamMembers.map((member, index) => (
                <div key={index} className="team-card">
                  <div className="team-photo">
                    <img src={member.photo} alt={`${member.name} - ${member.position} en Pereyra Inmobiliaria e Ingeniería, especialista en bienes raíces en Chiclayo`} />
                  </div>
                  <div className="team-info">
                    <h3>{member.name}</h3>
                    <h4>{member.position}</h4>
                    <p>{member.bio}</p>
                    {(member.phone || member.email) && (
                      <div className="team-contact">
                        {member.phone && (
                          <div className="contact-row">
                            <a href={`tel:+51${member.phone.replace(/\s/g, '')}`} className="contact-link phone-link">
                              <span className="contact-icon">📞</span> {member.phone}
                            </a>
                            <a href={`https://wa.me/51${member.phone.replace(/\s/g, '')}`} target="_blank" rel="noopener noreferrer" className="whatsapp-link">
                              <span className="whatsapp-icon">💬</span>
                            </a>
                          </div>
                        )}
                        {member.email && (
                          <div className="contact-row">
                            <a href={`mailto:${member.email}`} className="contact-link email-link">
                              <span className="contact-icon">✉️</span> {member.email}
                            </a>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Mobile Carousel */}
            <div className="team-mobile-carousel">
              <div className="carousel-container">
                <div
                  className={`team-carousel-slide slide-${teamTransitionDirection}`}
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={() => handleTouchEnd('team')}
                  key={currentTeamMember}
                >
                  <div className="team-card">
                    <div className="team-photo">
                      <img src={teamMembers[currentTeamMember].photo} alt={`${teamMembers[currentTeamMember].name} - ${teamMembers[currentTeamMember].position} en Pereyra Inmobiliaria e Ingeniería`} />
                    </div>
                    <div className="team-info">
                      <h3>{teamMembers[currentTeamMember].name}</h3>
                      <h4>{teamMembers[currentTeamMember].position}</h4>
                      <p>{teamMembers[currentTeamMember].bio}</p>
                      {(teamMembers[currentTeamMember].phone || teamMembers[currentTeamMember].email) && (
                        <div className="team-contact">
                          {teamMembers[currentTeamMember].phone && (
                            <div className="contact-row">
                              <a href={`tel:+51${teamMembers[currentTeamMember].phone?.replace(/\s/g, '') || ''}`} className="contact-link phone-link">
                                <span className="contact-icon">📞</span> {teamMembers[currentTeamMember].phone}
                              </a>
                              <a href={`https://wa.me/51${teamMembers[currentTeamMember].phone?.replace(/\s/g, '') || ''}`} target="_blank" rel="noopener noreferrer" className="whatsapp-link">
                                <span className="whatsapp-icon">💬</span>
                              </a>
                            </div>
                          )}
                          {teamMembers[currentTeamMember].email && (
                            <div className="contact-row">
                              <a href={`mailto:${teamMembers[currentTeamMember].email}`} className="contact-link email-link">
                                <span className="contact-icon">✉️</span> {teamMembers[currentTeamMember].email}
                              </a>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="carousel-controls">
                  <button className="carousel-btn prev" onClick={() => changeTeamMember(-1)}>‹</button>
                  <div className="carousel-dots">
                    {teamMembers.map((_, index) => (
                      <span key={index} className={`dot ${currentTeamMember === index ? 'active' : ''}`} onClick={() => goToTeamMember(index)}></span>
                    ))}
                  </div>
                  <button className="carousel-btn next" onClick={() => changeTeamMember(1)}>›</button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Projects Section */}
        <section id="proyectos" className="projects">
          <div className="container">
            <h2>Nuestros Proyectos</h2>
            <p className="section-subtitle">
              Descubre algunos de nuestros proyectos más destacados en Chiclayo y alrededores
            </p>

            {/* Desktop Grid */}
            <div className="projects-grid">
              {projects.map((project, index) => (
                <div key={index} className="project-card">
                  <div className="project-image">
                    <img src={project.photo} alt={`${project.name} - Proyecto inmobiliario de Pereyra Inmobiliaria e Ingeniería en Chiclayo, Perú. ${project.description}`} />
                  </div>
                  <div className="project-info">
                    <h3>{project.name}</h3>
                    <p>{project.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Mobile Carousel */}
            <div className="projects-mobile-carousel">
              <div className="carousel-container">
                <div
                  className={`project-carousel-slide slide-${projectTransitionDirection}`}
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={() => handleTouchEnd('project')}
                  key={currentProject}
                >
                  <div className="project-card">
                    <div className="project-image">
                      <img src={projects[currentProject].photo} alt={`${projects[currentProject].name} - Proyecto inmobiliario de Pereyra Inmobiliaria e Ingeniería`} />
                    </div>
                    <div className="project-info">
                      <h3>{projects[currentProject].name}</h3>
                      <p>{projects[currentProject].description}</p>
                    </div>
                  </div>
                </div>

                <div className="carousel-controls">
                  <button className="carousel-btn prev" onClick={() => changeProject(-1)}>‹</button>
                  <div className="carousel-dots">
                    {projects.map((_, index) => (
                      <span key={index} className={`dot ${currentProject === index ? 'active' : ''}`} onClick={() => goToProject(index)}></span>
                    ))}
                  </div>
                  <button className="carousel-btn next" onClick={() => changeProject(1)}>›</button>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section id="testimonios" className="testimonials">
          <div className="container">
            <h2>Lo que dicen nuestros clientes</h2>
            <p className="section-subtitle">
              Conoce las experiencias reales de quienes han confiado en nosotros para cumplir el sueño de su vivienda propia
            </p>

            <div className="testimonials-grid">
              <div className="testimonial-video">
                <div style={{ padding: '177.78% 0 0 0', position: 'relative' }}>
                  <iframe
                    src="https://player.vimeo.com/video/1089781427?h=b2094acf3b&badge=0&autopause=0&player_id=0&app_id=58479&title=0&byline=0&portrait=0"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', borderRadius: '15px' }}
                    title="Testimonial 1"
                  ></iframe>
                </div>
              </div>

              <div className="testimonial-video">
                <div style={{ padding: '177.78% 0 0 0', position: 'relative' }}>
                  <iframe
                    src="https://player.vimeo.com/video/1089782017?h=de11c16fd7&badge=0&autopause=0&player_id=0&app_id=58479&title=0&byline=0&portrait=0"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', borderRadius: '15px' }}
                    title="Testimonial 2"
                  ></iframe>
                </div>
              </div>

              <div className="testimonial-video">
                <div style={{ padding: '177.78% 0 0 0', position: 'relative' }}>
                  <iframe
                    src="https://player.vimeo.com/video/1091027365?h=de764d70a2&badge=0&autopause=0&player_id=0&app_id=58479&title=0&byline=0&portrait=0"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', borderRadius: '15px' }}
                    title="Testimonial 3"
                  ></iframe>
                </div>
              </div>
            </div>

            {/* Mobile Carousel Navigation */}
            <div className="testimonials-mobile">
              <div className="testimonials-carousel" id="testimonials-carousel">
                <div className={`testimonial-slide ${currentTestimonial === 0 ? 'active' : ''}`}>
                  <div style={{ padding: '177.78% 0 0 0', position: 'relative' }}>
                    <iframe
                      src="https://player.vimeo.com/video/1089781427?h=b2094acf3b&badge=0&autopause=0&player_id=0&app_id=58479&title=0&byline=0&portrait=0"
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', borderRadius: '15px' }}
                      title="Testimonial 1"
                    ></iframe>
                  </div>
                </div>

                <div className={`testimonial-slide ${currentTestimonial === 1 ? 'active' : ''}`}>
                  <div style={{ padding: '177.78% 0 0 0', position: 'relative' }}>
                    <iframe
                      src="https://player.vimeo.com/video/1089782017?h=de11c16fd7&badge=0&autopause=0&player_id=0&app_id=58479&title=0&byline=0&portrait=0"
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', borderRadius: '15px' }}
                      title="Testimonial 2"
                    ></iframe>
                  </div>
                </div>

                <div className={`testimonial-slide ${currentTestimonial === 2 ? 'active' : ''}`}>
                  <div style={{ padding: '177.78% 0 0 0', position: 'relative' }}>
                    <iframe
                      src="https://player.vimeo.com/video/1091027365?h=de764d70a2&badge=0&autopause=0&player_id=0&app_id=58479&title=0&byline=0&portrait=0"
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', borderRadius: '15px' }}
                      title="Testimonial 3"
                    ></iframe>
                  </div>
                </div>
              </div>

              <div className="carousel-controls">
                <button className="carousel-btn prev" onClick={() => changeTestimonial(-1)}>‹</button>
                <div className="carousel-dots">
                  <span className={`dot ${currentTestimonial === 0 ? 'active' : ''}`} onClick={() => goToTestimonial(0)}></span>
                  <span className={`dot ${currentTestimonial === 1 ? 'active' : ''}`} onClick={() => goToTestimonial(1)}></span>
                  <span className={`dot ${currentTestimonial === 2 ? 'active' : ''}`} onClick={() => goToTestimonial(2)}></span>
                </div>
                <button className="carousel-btn next" onClick={() => changeTestimonial(1)}>›</button>
              </div>
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section id="contacto" className="contact">
          <div className="container">
            <h2>Contáctanos</h2>
            <p className="section-subtitle">
              Estamos aquí para ayudarte a cumplir el sueño de tu vivienda propia
            </p>

            <div className="contact-card">
              <div className="contact-form-section">
                <h3>Envíanos un mensaje</h3>
                <form onSubmit={handleContactFormSubmit} className="contact-form">
                  <div className="form-group">
                    <input
                      type="text"
                      name="name"
                      placeholder="Nombre completo"
                      value={contactForm.name}
                      onChange={handleContactFormChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      placeholder="Correo electrónico"
                      value={contactForm.email}
                      onChange={handleContactFormChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="tel"
                      name="whatsapp"
                      placeholder="WhatsApp"
                      value={contactForm.whatsapp}
                      onChange={handleContactFormChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <textarea
                      name="message"
                      placeholder="Mensaje"
                      rows={4}
                      value={contactForm.message}
                      onChange={handleContactFormChange}
                      required
                    ></textarea>
                  </div>
                  <button type="submit" disabled={isSubmitting} className="submit-btn">
                    {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
                  </button>
                  {submitMessage && (
                    <p className={`submit-message ${submitMessage.includes('error') ? 'error' : 'success'}`}>
                      {submitMessage}
                    </p>
                  )}
                </form>
              </div>

              <div className="contact-info-section">
                <div className="map-container">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3957.1876754345897!2d-78.51768492678391!3d-7.1631325716973615!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x91b25af91aebd1c7%3A0x3041bd31e7a63!2sAv.%20M%C3%A1rtires%20de%20Uchuraccay%201340%2C%20Cajamarca%2006003!5e0!3m2!1sen!2spe!4v1710459163099!5m2!1sen!2spe"
                    width="100%"
                    height="300"
                    style={{ border: 0, borderRadius: '15px' }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Ubicación de Pereyra Inmobiliaria e Ingeniería en Av. Mártires de Uchuraccay 1340, Cajamarca, Perú"
                  ></iframe>
                </div>

                <div className="contact-details">
                  <div className="contact-item">
                    <span className="contact-icon">📍</span>
                    <div>
                      <h4>Dirección</h4>
                      <p>Av. Mártires de Uchuraccay N°1340, Cajamarca 06003</p>
                    </div>
                  </div>
                  <div className="contact-item">
                    <span className="contact-icon">📞</span>
                    <div>
                      <h4>Teléfonos</h4>
                      <p>
                        <a href="tel:+51964990661">+51 964 990 661</a> - <a href="tel:+51901202357">+51 901 202 357</a>
                      </p>
                    </div>
                  </div>
                  <div className="contact-item">
                    <span className="contact-icon">✉️</span>
                    <div>
                      <h4>Email</h4>
                      <p>yanperconstructora@gmail.com</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="contact-social-divider"></div>
              <div className="contact-social-links">
                <h3>Síguenos en redes sociales</h3>
                <div className="contact-social-buttons">
                  <SocialIcon
                    url="https://www.facebook.com/share/19GkcGLmHz/"
                    target="_blank"
                    style={{ height: 40, width: 40 }}
                    aria-label="Visitar Facebook de Pereyra Inmobiliaria"
                  />
                  <SocialIcon
                    url="https://www.instagram.com/pereyra_inmobiliaria?igsh=MWtwZ3VwbThnanExdw=="
                    target="_blank"
                    style={{ height: 40, width: 40 }}
                    aria-label="Visitar Instagram de Pereyra Inmobiliaria"
                  />
                  <SocialIcon
                    network="tiktok"
                    url="https://tiktok.com/@pereyra_inmobiliaria4268"
                    target="_blank"
                    style={{ height: 40, width: 40 }}
                    aria-label="Visitar TikTok de Pereyra Inmobiliaria"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-nav">
              <img src={logo} alt="Pereyra Inmobiliaria e Ingeniería - Los agentes inmobiliarios más confiables del norte del Perú" className="footer-logo" />
              <nav className="footer-links">
                <button onClick={() => scrollToSection('inicio')} className="footer-link">Inicio</button>
                <button onClick={() => scrollToSection('nosotros')} className="footer-link">Nosotros</button>
                <button onClick={() => scrollToSection('equipo')} className="footer-link">Equipo</button>
                <button onClick={() => scrollToSection('proyectos')} className="footer-link">Proyectos</button>
                <button onClick={() => scrollToSection('testimonios')} className="footer-link">Testimonios</button>
                <button onClick={() => scrollToSection('contacto')} className="footer-link">Contacto</button>
              </nav>
            </div>

            <div className="footer-bottom">
              <p>&copy; 2024 Pereyra Inmobiliaria e Ingeniería. Todos los derechos reservados.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
